import React, { useState } from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import theme from '@/config/theme';
import { MAX_OBSERVATION_LENGTH } from '@/services/checklist/checklistObservations';
import { traceImage } from '@/utils/debugImageTrace';
import { ExpandingTextInput } from './ExpandingTextInput';

interface ChecklistMediaObservationProps {
  fieldId: string;
  label: string;
  value: string;
  editable?: boolean;
  onChange: (value: string) => void;
}

const ChecklistMediaObservation = ({ fieldId, label, value, editable = true, onChange }: ChecklistMediaObservationProps) => {
  const [open, setOpen] = useState(Boolean(value));
  if (!editable) {
    return value ? <Text testID={`observation-preview-${fieldId}`} style={styles.preview}>{value}</Text> : null;
  }
  return <View style={styles.container}>
    <Pressable accessibilityRole="button" accessibilityLabel={`${open ? 'Recolher' : value ? 'Editar' : 'Adicionar'} observação de ${label}`}
      onPress={() => setOpen(current => !current)} style={styles.toggle}>
      <Text style={styles.link}>{open ? 'Recolher observação' : value ? 'Editar observação' : 'Adicionar observação'}</Text>
    </Pressable>
    {open ? <View>
      <ExpandingTextInput
        testID={`observation-${fieldId}`}
        accessibilityLabel={`Observação de ${label}`}
        placeholder="Descreva a observação deste item"
        placeholderTextColor={theme.colors.text.tertiary}
        style={styles.input}
        value={value}
        editable={editable}
        maxLength={MAX_OBSERVATION_LENGTH}
        onChangeText={text => {
          traceImage('checklist_observation_change', { fieldId, origin: 'onChangeText', length: text.length });
          onChange(text);
        }}
      />
      {value && editable ? <Pressable accessibilityRole="button" accessibilityLabel={`Remover observação de ${label}`}
        onPress={() => {
          traceImage('checklist_observation_change', { fieldId, origin: 'remove', length: 0 });
          onChange(''); setOpen(false);
        }} style={styles.toggle}>
        <Text style={styles.remove}>Remover observação</Text>
      </Pressable> : null}
    </View> : value ? <Text style={styles.preview}>{value}</Text> : null}
  </View>;
};

const styles = StyleSheet.create({
  container: { marginTop: 2 },
  toggle: { alignSelf: 'flex-start', paddingVertical: 10, minHeight: 44, justifyContent: 'center' },
  link: { fontSize: 12, color: theme.colors.primary.default },
  remove: { fontSize: 12, color: '#a53636' },
  input: { fontSize: 13, color: theme.colors.text.primary, borderWidth: 1, borderColor: theme.colors.border.light, borderRadius: 6, padding: 8, backgroundColor: theme.colors.background.primary },
  preview: { fontSize: 12, color: theme.colors.text.secondary, lineHeight: 18 },
});

export default ChecklistMediaObservation;
